export default __webpack_public_path__ + "static/media/game_theory.2c0825b9.png";